<template>
    <div :style="{ width, height }">
        <Address v-if="use == 'address'" />
        <Agent v-else-if="use == 'agent'" />
        <Allocation v-else-if="use == 'allocation'" />
        <ArrowSvg v-else-if="use == 'arrow'" />
        <BackArrow v-else-if="use === 'back-arrow'" />
        <BillingAccount v-else-if="use == 'billingaccount'" />
        <Bundle v-else-if="use == 'bundle'" />
        <BundleComponent v-else-if="use == 'bundlecomponent'" />
        <Campaign v-else-if="use == 'campaign'" />
        <StockEvolution v-else-if="use === 'stock-evolution'" />
        <InventoryReady v-else-if="use === 'inventory-ready'" />
        <InventoryDate v-else-if="use === 'inventory-date'" />
        <CalendarEmpty v-else-if="use === 'calendar-empty'" />
        <Catalog v-else-if="use == 'catalog'" />
        <City v-else-if="use == 'city'" />
        <Company v-else-if="use == 'company'" />
        <Connect v-else-if="use == 'connect' || use == 'possync'" />
        <CrossSvg v-else-if="use == 'cross'" />
        <Customer v-else-if="use == 'customer'" />
        <CustomerInvoice v-else-if="use == 'customerinvoice'" />
        <DefaultBundleIcon v-else-if="use == 'default-bundle'" />
        <DeliveryAddress v-else-if="use == 'delivery-address'" />
        <Document v-else-if="use == 'document'" />
        <Establishment v-else-if="use == 'establishment'" />
        <FilterSvg v-else-if="use == 'filter'" />
        <Folder v-else-if="use == 'folder'" />
        <HideSvg v-else-if="use == 'hide'" />
        <Knowledge v-else-if="use == 'knowledge'" />
        <Logistics v-else-if="use == 'logistics'" />
        <Logo v-else-if="use == 'logo'" />
        <LogoXs v-else-if="use == 'logoxs'" />
        <MagnifierSvg v-else-if="use == 'magnifier'" />
        <MenuSvg v-else-if="use == 'menu'" />
        <Movement v-else-if="use == 'movement'" />
        <NoData v-else-if="use == 'nodata'" />
        <NoResult v-else-if="use == 'noresult'" />
        <OrderComponents v-else-if="use == 'ordercomponents'" />
        <Pdf v-else-if="use == 'pdf'" />
        <Picture v-else-if="use == 'picture'" />
        <Product v-else-if="use == 'product'" />
        <Project v-else-if="use == 'project'" />
        <Provider v-else-if="use == 'provider'" />
        <ProviderInvoice v-else-if="use == 'providerinvoice'" />
        <Purchase v-else-if="use == 'purchase'" />
        <Receipt v-else-if="use == 'receipt'" />
        <Sale v-else-if="use == 'sale'" />
        <Shipment v-else-if="use == 'shipment'" />
        <Signup v-else-if="use == 'signup'" />
        <SmartPhone v-else-if="use == 'smartphone'" />
        <Start v-else-if="use == 'start'" />
        <Stock v-else-if="use == 'stock'" />
        <Subscription v-else-if="use == 'subscription'" />
        <Task v-else-if="use == 'task'" />
        <Telephone v-else-if="use == 'telephone'" />
        <Warehouse v-else-if="use == 'warehouse'" />
        <Welcome v-else-if="use == 'welcome'" />
        <ApprovalsDone v-else-if="use == 'approvals-done'" />
        <div v-else>Did not find {{ use }}</div>
    </div>
</template>

<script>
import Address from "@/assets/svg/common/address.vue";
import Agent from "@/assets/svg/common/agent.vue";
import Allocation from "@/assets/svg/common/allocation.vue";
import ArrowSvg from "@/assets/svg/common/arrow.vue";
import BackArrow from "@/assets/svg/common/back-arrow.vue";
import BillingAccount from "@/assets/svg/common/billingaccount.vue";
import Bundle from "@/assets/svg/common/bundle.vue";
import BundleComponent from "@/assets/svg/common/bundlecomponent.vue";
import Campaign from "@/assets/svg/common/campaign.vue";
import Catalog from "@/assets/svg/common/catalog.vue";
import City from "@/assets/svg/common/city.vue";
import Company from "@/assets/svg/common/company.vue";
import Connect from "@/assets/svg/illustration/connect.vue";
import CrossSvg from "@/assets/svg/common/cross.vue";
import Customer from "@/assets/svg/common/customer.vue";
import CustomerInvoice from "@/assets/svg/common/customerinvoice.vue";
import DefaultBundleIcon from "@/assets/svg/common/default-bundle.vue";
import DeliveryAddress from "@/assets/svg/common/delivery-address.vue";
import Document from "@/assets/svg/common/document.vue";
import Establishment from "@/assets/svg/common/establishment.vue";
import FilterSvg from "@/assets/svg/common/filter.vue";
import Folder from "@/assets/svg/common/folder.vue";
import HideSvg from "@/assets/svg/common/hide.vue";
import Knowledge from "@/assets/svg/common/knowledge.vue";
import Logistics from "@/assets/svg/common/logistics.vue";
import Logo from "@/assets/svg/common/logo.vue";
import LogoXs from "@/assets/svg/common/logo-xs.vue";
import MagnifierSvg from "@/assets/svg/common/magnifier.vue";
import MenuSvg from "@/assets/svg/common/menu.vue";
import Movement from "@/assets/svg/common/movement.vue";
import StockEvolution from "@/assets/svg/common/stock-evolution.vue";
import InventoryReady from "@/assets/svg/common/inventory-ready.vue";
import InventoryDate from "@/assets/svg/common/inventory-date.vue";
import CalendarEmpty from "@/assets/svg/common/calendar-empty.vue";
import NoData from "@/assets/svg/common/nodata.vue";
import NoResult from "@/assets/svg/common/noresult.vue";
import OrderComponents from "@/assets/svg/common/ordercomponents.vue";
import Pdf from "@/assets/svg/common/pdf.vue";
import Picture from "@/assets/svg/common/picture.vue";
import Product from "@/assets/svg/common/product.vue";
import Project from "@/assets/svg/common/project.vue";
import Provider from "@/assets/svg/common/provider.vue";
import ProviderInvoice from "@/assets/svg/common/providerinvoice.vue";
import Purchase from "@/assets/svg/common/purchase.vue";
import Receipt from "@/assets/svg/common/receipt.vue";
import Sale from "@/assets/svg/common/sale.vue";
import Shipment from "@/assets/svg/common/shipment.vue";
import Signup from "@/assets/svg/illustration/signup.vue";
import SmartPhone from "@/assets/svg/common/smartphone.vue";
import Start from "@/assets/svg/common/start.vue";
import Stock from "@/assets/svg/common/stock.vue";
import Subscription from "@/assets/svg/common/subscription.vue";
import Task from "@/assets/svg/common/task.vue";
import Telephone from "@/assets/svg/common/telephone.vue";
import Warehouse from "@/assets/svg/common/warehouse.vue";
import Welcome from "@/assets/svg/illustration/welcome.vue";
import ApprovalsDone from "@/assets/svg/illustration/approvals-done.vue";

export default {
    components: {
        CalendarEmpty,
        InventoryDate,
        InventoryReady,
        StockEvolution,
        Address,
        Agent,
        Allocation,
        ArrowSvg,
        BackArrow,
        BillingAccount,
        Bundle,
        BundleComponent,
        Campaign,
        Catalog,
        City,
        Company,
        Connect,
        CrossSvg,
        Customer,
        CustomerInvoice,
        DefaultBundleIcon,
        DeliveryAddress,
        Document,
        Establishment,
        FilterSvg,
        Folder,
        HideSvg,
        Knowledge,
        Logistics,
        Logo,
        LogoXs,
        MagnifierSvg,
        MenuSvg,
        Movement,
        NoData,
        NoResult,
        OrderComponents,
        Pdf,
        Picture,
        Product,
        Project,
        Provider,
        ProviderInvoice,
        Purchase,
        Receipt,
        Sale,
        Shipment,
        Signup,
        SmartPhone,
        Start,
        Stock,
        Subscription,
        Task,
        Telephone,
        Warehouse,
        Welcome,
        ApprovalsDone,
    },
    props: {
        use: {
            type: String,
            required: true,
        },
        width: {
            type: Number,
            required: false,
        },
        height: {   
            type: Number,
            required: false,
        },
    },
};
</script>
